<template>
  <div>
    <el-dialog
      title="项目位置"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :width="$store.getters.tagsView?'50%':'90%'"
      :close-on-click-modal="false"
    >
      <div v-if="dialogVisible">
        <baidu-map
          :style="{width:map.width,height:map.height}"
          class="bm-view"
          :ak="Ak"
          :center="{lng: center.lng, lat: center.lat}"
          :zoom="zoom"
          :scroll-wheel-zoom="true"
          @ready="handler"
          v-loading="loading"
          @zoomend="handleAndZoom"
        >
          <!-- 缩放控件 -->
          <!-- <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-navigation> -->
          <!-- 渲染百度地图实例可视化区域的容器 -->
          <bm-view style="width: 100%; height:500px;"></bm-view>
          <!-- 加的点坐标 -->
          <bm-marker
            :position="{lng: center.lng, lat: center.lat}"
            :size=" {width: 300, height: 157}"
            @dragend="dragend"
          ></bm-marker>

          <!-- 自定义覆盖物 -->
          <bm-overlay pane="floatPane" :class="{sample: true}" @draw="draw" v-if="isMaskeoverlay">
            <div class="card">{{this.address}}</div>
          </bm-overlay>
        </baidu-map>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  BaiduMap,
  BmControl,
  BmView,
  BmAutoComplete,
  BmLocalSearch,
  BmMarker,
  BmNavigation,
  BmOverlay
} from "vue-baidu-map";
import { Ak } from "@/utils/config.js";
export default {
  name: "MapReadyDialog",
  components: {
    BaiduMap,
    BmControl,
    BmView,
    BmAutoComplete,
    BmLocalSearch,
    BmMarker,
    BmNavigation,
    BmOverlay
  },
  props: {
    dialogVisible: Boolean,
    center: {
      type: Object,
      default: {}
    },
    address: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      Ak,
      zoom: 16,
      map: {
        width: "600",
        height: "500"
      },
      loading: false,
      active: false,
      isMaskeoverlay:true,
    };
  },
  created() {},
  methods: {
    //  地图初始化
    handler({ BMap, map }) {
      this.loading = true;
      this.$nextTick(() => {
        //   可以用来设置高宽
        this.map.width = "100%";
        this.map.height = "100%";
        this.zoom = 19
        this.loading = false;
      });
    },
    // 关闭弹窗之前的操作
    handleClose() {
      this.$emit("cancel");
    },

    // 拖拽结束以后
    dragend(e) {
      //   const { lng, lat } = e.target.point;
      //   this.center.lng = lng;
      //   this.center.lat = lat;
    },
    // 缩放以后 的问题
    handleAndZoom(e) {
      this.isMaskeoverlay = false;
     setTimeout(()=>{ this.isMaskeoverlay = true},100)
    },
    draw({ el, BMap, map }) {
      let lng = this.center.lng;
      let lat = this.center.lat;
      const pixel = map.pointToOverlayPixel(new BMap.Point(lng, lat));
      el.style.left = pixel.x - el.clientWidth / 2 + 5 + "px";
      el.style.top = pixel.y - el.clientHeight - 25 + "px";
    }
  }
};
</script>

<style lang="scss" scoped>
.sample {
  width: 200px;
  max-height: 53px;
  min-height: 24px;
  text-align: center;
  background: #fff;
  color: #333;
  font-size: 14px;
  font-weight: bold;
  border-radius: 8px;
  box-shadow: 1px 2px 7px 1px #5048488a;
  padding: 10px;
  position: absolute;
  z-index: 3;
  &::after {
    display: block;
    content: "";
    border-width: 14px 14px 14px 14px;
    border-style: solid;
    border-color: #fff transparent transparent transparent;

    /* 定位 */
    position: absolute;
    left: 41.7%;
    top: 100%;
  }
  .card {
    width: 100%;
    max-height: 50px;
    overflow-y: auto;
  }
}
</style>